import '../App.css';
import axios from 'axios';
import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import V2HomeCard from '../V2HomeCard';
import CampaignNewStepTitle from './CampaignNewStepTitle';
import CampaignNewStepPreview from './CampaignNewStepPreview';
import CampaignNewStepMaxSeconds from './CampaignNewStepMaxSeconds';
import CampaignNewStepUpload from './CampaignNewStepUpload';

function CampaignNew({ menu }) {
    const navigate = useNavigate();

    const [step, setStep] = useState('title');

    const [title, setTitle] = useState(null);
    const [creativeURL, setCreativeURL] = useState('');
    const [creativeExt, setCreativeExt] = useState('');
    const [previewURL, setPreviewURL] = useState(null);
    const [previewExt, setPreviewExt] = useState(null);
    const [previewMediaFileUUID, setPreviewMediaFileUUID] = useState(null);

    const [maxSecondsToDisplay, setMaxSecondsToDisplay] = useState(10);

    function createCampaign() {
        axios.post(
            process.env.REACT_APP_API_HOST + '/campaigns/',
            {
                title: title,
                creative_url: creativeURL,
                creative_ext: creativeExt,
                status: 'active',
                creative_max_seconds_to_display: maxSecondsToDisplay,
                creative_is_muted: true,
                preview_media_file_uuid: previewMediaFileUUID,
            },
            {
                headers: {
                    'Authorization': localStorage.getItem('token'),
                }
            }
        ).then(
            (response) => {
                const campaign_id = response.data.campaign_id;
                setTitle('');
                setCreativeURL('');
                navigate(`/campaign?campaign_id=${campaign_id}`);
            }
        )
    }

    return (
        <div align='center'>
            {menu}
            <V2HomeCard>
                <div align='center'>

                    <div
                        style={{ width: '20em' }}
                        align='left'
                    >
                        {
                            step == 'title' &&
                            <CampaignNewStepTitle
                                title={title}
                                setTitle={setTitle}
                                setStep={(setStep)}
                            />
                        }
                        {
                            step == 'upload' &&
                            <CampaignNewStepUpload
                                setStep={setStep}
                                creativeURL={creativeURL}
                                setCreativeURL={setCreativeURL}
                                creativeExt={creativeExt}
                                setCreativeExt={setCreativeExt}
                                setPreviewMediaFileUUID={setPreviewMediaFileUUID}
                                previewURL={previewURL}
                                setPreviewURL={setPreviewURL}
                                previewExt={previewExt}
                                setPreviewExt={setPreviewExt}
                            />
                        }
                        {
                            step == 'preview' && previewURL &&
                            <CampaignNewStepPreview
                                setStep={setStep}
                                previewURL={previewURL}
                                maxSecondsToDisplay={maxSecondsToDisplay}
                            />
                        }
                        {
                            step == 'set_time_to_display' &&
                            <CampaignNewStepMaxSeconds
                                setStep={setStep}
                                title={title}
                                creativeURL={creativeURL}
                                previewURL={previewURL}
                                maxSecondsToDisplay={maxSecondsToDisplay}
                                setMaxSecondsToDisplay={setMaxSecondsToDisplay}
                                createCampaign={createCampaign}
                            />
                        }
                    </div>
                </div>
            </V2HomeCard >
        </div>
    );
}

export default CampaignNew;